export var MaterialType;
(function (MaterialType) {
    MaterialType["StainlessSteel304"] = "304_stainless_steel";
    MaterialType["StainlessSteel316"] = "316_stainless_steel";
    MaterialType["CopperBearingSteel"] = "copper_bearing_steel";
    MaterialType["HSLA"] = "hsla";
    MaterialType["MildSteel"] = "mild_steel";
})(MaterialType || (MaterialType = {}));
export var MaterialPart;
(function (MaterialPart) {
    MaterialPart["GravelTube"] = "gravel_tube";
    MaterialPart["SoundingTube"] = "sounding_tube";
    MaterialPart["WellCasingScreen"] = "well_casing_screen";
})(MaterialPart || (MaterialPart = {}));
